import { Component, Element, Host, h, Prop, Watch } from "@stencil/core";

/**
 * @slot image - Slot for the image (`<picture>` or `<img>`)
 * @slot title - Slot for the headline (`<h2>` or `<h3>`)
 * @slot cta - Slot for the call-to-action button (`<ux-button>`)
 * @slot (default) - Slot for the text content
 */
@Component({
    tag: "ux-iws-nb-all-in-one-detail",
    styleUrl: "nb-all-in-one-detail.scss",
    shadow: false,
})
export class NbAllInOneDetail {
    private static uidIncrement = 0;
    private uid = `nb-all-in-one-detail-${NbAllInOneDetail.uidIncrement++}`;

    /** The element reference for the component. */
    @Element() host: HTMLUxIwsNbAllInOneDetailElement;

    /** Label used for the group radio button */
    @Prop({ reflect: true }) label: string = "";

    /** Category label shown above the headline */
    @Prop({ reflect: true }) category: string = "";

    /** Indicates if the tile is active or not */
    @Prop({ mutable: true, reflect: true }) active: boolean = false;

    @Watch("active")
    handleActiveChange(active: boolean) {
        if (!active) {
            return;
        }
        const siblings =
            this.host.parentElement.querySelectorAll<HTMLUxIwsNbAllInOneDetailElement>(
                "ux-iws-nb-all-in-one-detail"
            );
        siblings.forEach((el) => (el.active = el === this.host));
    }

    render() {
        const baseClass = "ux-iws-nb-all-in-one-detail";
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--active`]: this.active,
                }}
            >
                <article
                    class={`${baseClass}__inner`}
                    aria-labelledby={`${this.uid}-title`}
                    aria-describedby={`${this.uid}-description`}
                >
                    <div class={`${baseClass}__image`}>
                        <slot name="image" />
                    </div>
                    <div class={`${baseClass}__content`}>
                        {this.category && (
                            <div class="ux-label">{this.category}</div>
                        )}
                        <div
                            class={`${baseClass}__title`}
                            id={`${this.uid}-title`}
                        >
                            <slot name="title" />
                        </div>
                        <div
                            class={`${baseClass}__text`}
                            id={`${this.uid}-description`}
                        >
                            <slot />
                        </div>
                        <div class={`${baseClass}__cta`}>
                            <slot name="cta" />
                        </div>
                    </div>
                </article>
            </Host>
        );
    }
}
